// Communication Module Mock Data

import {
  Announcement,
  Message,
  FeeReminder,
  Notification,
  StudentRecipient,
  EmployeeRecipient,
  FeeDefaulter,
  CommunicationHistory,
  AudienceType,
  MessageType,
  NotificationType,
  NotificationPriority,
  DeliveryStatus,
} from '../types/communication';

// ============================================
// MOCK ANNOUNCEMENTS
// ============================================

export const MOCK_ANNOUNCEMENTS: Announcement[] = [
  {
    id: 'ann_001',
    title: '🎉 Annual Day Celebration',
    body: 'Our school Annual Day will be celebrated on March 20th, 2026. All students are requested to attend. Parents are cordially invited.',
    audience: AudienceType.ALL_STUDENTS,
    targetDetail: 'All',
    showAsPopup: true,
    createdAt: '2026-02-10T10:00:00Z',
    createdBy: {
      id: 'user_001',
      name: 'Principal',
      role: 'Admin',
    },
    recipientCount: 850,
    deliveryStatus: DeliveryStatus.DELIVERED,
  },
  {
    id: 'ann_002',
    title: 'Science Fair Tomorrow 🚀',
    body: 'Science fair for classes 6-10 will be held tomorrow in the school auditorium. Students should bring their projects.',
    audience: AudienceType.CLASS_WISE,
    targetDetail: 'Class 6, Class 7, Class 8, Class 9, Class 10',
    targetIds: ['class_6', 'class_7', 'class_8', 'class_9', 'class_10'],
    showAsPopup: false,
    createdAt: '2026-02-14T09:00:00Z',
    createdBy: {
      id: 'user_002',
      name: 'John Doe',
      role: 'Teacher',
    },
    recipientCount: 450,
    deliveryStatus: DeliveryStatus.SENT,
  },
  {
    id: 'ann_003',
    title: 'Staff Meeting - Urgent',
    body: 'All teaching staff members are requested to attend an urgent meeting in the staff room at 4 PM today.',
    audience: AudienceType.ALL_STAFF,
    targetDetail: 'All',
    showAsPopup: true,
    createdAt: '2026-02-15T11:00:00Z',
    createdBy: {
      id: 'user_001',
      name: 'Principal',
      role: 'Admin',
    },
    recipientCount: 65,
    deliveryStatus: DeliveryStatus.DELIVERED,
  },
  {
    id: 'ann_004',
    title: 'Sports Day Registration Open',
    body: 'Registration for Sports Day events is now open. Students interested in participating should register by February 20th.',
    audience: AudienceType.ALL_STUDENTS,
    targetDetail: 'All',
    showAsPopup: false,
    createdAt: '2026-02-12T14:30:00Z',
    createdBy: {
      id: 'user_003',
      name: 'Sports Teacher',
      role: 'Teacher',
    },
    recipientCount: 850,
    deliveryStatus: DeliveryStatus.READ,
  },
  {
    id: 'ann_005',
    title: 'Library Closure Notice',
    body: 'The school library will remain closed from February 18-20 for maintenance work. Students are requested to plan accordingly.',
    audience: AudienceType.ALL_STUDENTS,
    targetDetail: 'All',
    showAsPopup: false,
    createdAt: '2026-02-13T16:00:00Z',
    createdBy: {
      id: 'user_004',
      name: 'Librarian',
      role: 'Employee',
    },
    recipientCount: 850,
    deliveryStatus: DeliveryStatus.DELIVERED,
  },
];

// ============================================
// MOCK MESSAGES
// ============================================

const mockStudentRecipients: StudentRecipient[] = [
  {
    id: 'stu_001',
    rType: 'STUDENT',
    name: 'Rahul Sharma',
    admissionNo: 'ADM2024001',
    classId: 'class_10',
    className: 'Class 10',
    mobile: '9876543210',
    email: 'rahul.parent@example.com',
  },
  {
    id: 'stu_002',
    rType: 'STUDENT',
    name: 'Priya Patel',
    admissionNo: 'ADM2024002',
    classId: 'class_9',
    className: 'Class 9',
    mobile: '9876543211',
    email: 'priya.parent@example.com',
  },
];

export const MOCK_MESSAGES: Message[] = [
  {
    id: 'msg_001',
    recipients: [mockStudentRecipients[0]],
    content: 'Your child was absent today. Please send a leave application or contact the school.',
    type: MessageType.INFO,
    showAsPopup: false,
    sentAt: '2026-02-15T08:30:00Z',
    sentBy: {
      id: 'user_002',
      name: 'John Doe',
      role: 'Teacher',
    },
    deliveryStatus: DeliveryStatus.DELIVERED,
    readBy: [],
  },
  {
    id: 'msg_002',
    recipients: mockStudentRecipients,
    content: 'Homework for Mathematics: Complete exercises 5.1 to 5.5 from the textbook. Submission deadline is tomorrow.',
    type: MessageType.INFO,
    showAsPopup: false,
    sentAt: '2026-02-14T15:00:00Z',
    sentBy: {
      id: 'user_002',
      name: 'John Doe',
      role: 'Teacher',
    },
    deliveryStatus: DeliveryStatus.READ,
    readBy: ['stu_001', 'stu_002'],
  },
  {
    id: 'msg_003',
    recipients: [mockStudentRecipients[1]],
    content: 'URGENT: Please collect your exam admit card from the office by today 5 PM.',
    type: MessageType.URGENT,
    showAsPopup: true,
    sentAt: '2026-02-15T12:00:00Z',
    sentBy: {
      id: 'user_005',
      name: 'Office Admin',
      role: 'Admin',
    },
    deliveryStatus: DeliveryStatus.SENT,
    readBy: [],
  },
];

// ============================================
// MOCK FEE REMINDERS
// ============================================

export const MOCK_FEE_REMINDERS: FeeReminder[] = [
  {
    id: 'fee_001',
    studentIds: ['stu_001', 'stu_002', 'stu_003'],
    message: 'Dear Parent, fee payment is pending. Please clear the dues at your earliest convenience to avoid inconvenience.',
    sentAt: '2026-02-10T10:00:00Z',
    sentBy: {
      id: 'user_001',
      name: 'Accounts Manager',
      role: 'Admin',
    },
    totalDue: 45000,
    deliveryStatus: DeliveryStatus.DELIVERED,
    classId: 'class_10',
  },
  {
    id: 'fee_002',
    studentIds: ['stu_004', 'stu_005'],
    message: 'URGENT: Your child\'s fee payment is overdue. Kindly clear the pending amount immediately to avoid late fees.',
    sentAt: '2026-02-12T14:00:00Z',
    sentBy: {
      id: 'user_001',
      name: 'Accounts Manager',
      role: 'Admin',
    },
    totalDue: 28000,
    deliveryStatus: DeliveryStatus.SENT,
  },
];

// ============================================
// MOCK NOTIFICATIONS
// ============================================

export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: 'notif_001',
    userId: 'user_current',
    type: NotificationType.ANNOUNCEMENT,
    title: 'New Announcement',
    message: 'Annual Day Celebration scheduled for March 20th',
    relatedEntityId: 'ann_001',
    relatedEntityType: 'ANNOUNCEMENT',
    actionUrl: '/communication?announcement=ann_001',
    isRead: false,
    priority: NotificationPriority.HIGH,
    createdAt: '2026-02-15T09:00:00Z',
  },
  {
    id: 'notif_002',
    userId: 'user_current',
    type: NotificationType.MESSAGE,
    title: 'New Message from John Doe',
    message: 'Homework for Mathematics: Complete exercises 5.1 to 5.5',
    relatedEntityId: 'msg_002',
    relatedEntityType: 'MESSAGE',
    actionUrl: '/communication?message=msg_002',
    isRead: false,
    priority: NotificationPriority.NORMAL,
    createdAt: '2026-02-15T08:45:00Z',
  },
  {
    id: 'notif_003',
    userId: 'user_current',
    type: NotificationType.FEE_REMINDER,
    title: 'Fee Payment Reminder',
    message: 'Fee payment is pending. Please clear dues.',
    relatedEntityId: 'fee_001',
    relatedEntityType: 'FEE_REMINDER',
    actionUrl: '/fees/collectfees',
    isRead: true,
    priority: NotificationPriority.NORMAL,
    createdAt: '2026-02-14T10:00:00Z',
    readAt: '2026-02-14T11:30:00Z',
  },
  {
    id: 'notif_004',
    userId: 'user_current',
    type: NotificationType.APPROVAL,
    title: 'Leave Request Approved',
    message: 'Your leave request for Feb 20-22 has been approved',
    relatedEntityId: 'leave_001',
    relatedEntityType: 'LEAVE',
    actionUrl: '/leaves',
    isRead: true,
    priority: NotificationPriority.NORMAL,
    createdAt: '2026-02-13T16:00:00Z',
    readAt: '2026-02-13T17:00:00Z',
  },
  {
    id: 'notif_005',
    userId: 'user_current',
    type: NotificationType.EVENT,
    title: 'Science Fair Tomorrow',
    message: 'Science fair for classes 6-10 will be held tomorrow',
    relatedEntityId: 'ann_002',
    relatedEntityType: 'ANNOUNCEMENT',
    actionUrl: '/communication?announcement=ann_002',
    isRead: false,
    priority: NotificationPriority.HIGH,
    createdAt: '2026-02-15T09:15:00Z',
  },
  {
    id: 'notif_006',
    userId: 'user_current',
    type: NotificationType.SYSTEM,
    title: 'Profile Updated',
    message: 'Your profile information has been successfully updated',
    isRead: true,
    priority: NotificationPriority.LOW,
    createdAt: '2026-02-12T14:30:00Z',
    readAt: '2026-02-12T15:00:00Z',
  },
  {
    id: 'notif_007',
    userId: 'user_current',
    type: NotificationType.ANNOUNCEMENT,
    title: 'Staff Meeting - Urgent',
    message: 'All staff members requested to attend meeting at 4 PM',
    relatedEntityId: 'ann_003',
    relatedEntityType: 'ANNOUNCEMENT',
    actionUrl: '/communication?announcement=ann_003',
    isRead: false,
    priority: NotificationPriority.URGENT,
    createdAt: '2026-02-15T11:00:00Z',
  },
  {
    id: 'notif_008',
    userId: 'user_current',
    type: NotificationType.MESSAGE,
    title: 'Urgent Message',
    message: 'Please collect exam admit card by today 5 PM',
    relatedEntityId: 'msg_003',
    relatedEntityType: 'MESSAGE',
    actionUrl: '/communication?message=msg_003',
    isRead: false,
    priority: NotificationPriority.URGENT,
    createdAt: '2026-02-15T12:00:00Z',
  },
  {
    id: 'notif_009',
    userId: 'user_current',
    type: NotificationType.EVENT,
    title: 'Sports Day Registration',
    message: 'Registration now open. Register by Feb 20th',
    relatedEntityId: 'ann_004',
    relatedEntityType: 'ANNOUNCEMENT',
    actionUrl: '/communication?announcement=ann_004',
    isRead: true,
    priority: NotificationPriority.NORMAL,
    createdAt: '2026-02-12T14:30:00Z',
    readAt: '2026-02-12T16:00:00Z',
  },
  {
    id: 'notif_010',
    userId: 'user_current',
    type: NotificationType.SYSTEM,
    title: 'Library Closure Notice',
    message: 'Library closed Feb 18-20 for maintenance',
    relatedEntityId: 'ann_005',
    relatedEntityType: 'ANNOUNCEMENT',
    actionUrl: '/communication?announcement=ann_005',
    isRead: true,
    priority: NotificationPriority.LOW,
    createdAt: '2026-02-13T16:00:00Z',
    readAt: '2026-02-14T09:00:00Z',
  },
];

// ============================================
// MOCK FEE DEFAULTERS
// ============================================

export const MOCK_FEE_DEFAULTERS: FeeDefaulter[] = [
  {
    studentId: 'stu_d001',
    studentName: 'Amit Kumar',
    admissionNo: 'ADM2024101',
    classId: 'class_10',
    className: 'Class 10',
    mobile: '9876543201',
    parentMobile: '9876543202',
    totalFee: 50000,
    paidFee: 15000,
    feeBalance: 35000,
    lastReminderSent: '2026-02-10T10:00:00Z',
    reminderCount: 2,
  },
  {
    studentId: 'stu_d002',
    studentName: 'Sneha Reddy',
    admissionNo: 'ADM2024102',
    classId: 'class_9',
    className: 'Class 9',
    mobile: '9876543203',
    parentMobile: '9876543204',
    totalFee: 45000,
    paidFee: 10000,
    feeBalance: 35000,
    lastReminderSent: '2026-02-08T14:00:00Z',
    reminderCount: 3,
  },
  {
    studentId: 'stu_d003',
    studentName: 'Rajesh Verma',
    admissionNo: 'ADM2024103',
    classId: 'class_10',
    className: 'Class 10',
    mobile: '9876543205',
    totalFee: 50000,
    paidFee: 22000,
    feeBalance: 28000,
    lastReminderSent: '2026-02-12T09:00:00Z',
    reminderCount: 1,
  },
  {
    studentId: 'stu_d004',
    studentName: 'Pooja Singh',
    admissionNo: 'ADM2024104',
    classId: 'class_8',
    className: 'Class 8',
    mobile: '9876543206',
    parentMobile: '9876543207',
    totalFee: 40000,
    paidFee: 18000,
    feeBalance: 22000,
    reminderCount: 0,
  },
  {
    studentId: 'stu_d005',
    studentName: 'Vikram Joshi',
    admissionNo: 'ADM2024105',
    classId: 'class_7',
    className: 'Class 7',
    mobile: '9876543208',
    totalFee: 38000,
    paidFee: 20000,
    feeBalance: 18000,
    lastReminderSent: '2026-02-11T11:00:00Z',
    reminderCount: 1,
  },
  {
    studentId: 'stu_d006',
    studentName: 'Ananya Desai',
    admissionNo: 'ADM2024106',
    classId: 'class_10',
    className: 'Class 10',
    mobile: '9876543209',
    parentMobile: '9876543210',
    totalFee: 50000,
    paidFee: 35000,
    feeBalance: 15000,
    lastReminderSent: '2026-02-14T10:30:00Z',
    reminderCount: 1,
  },
  {
    studentId: 'stu_d007',
    studentName: 'Karthik Nair',
    admissionNo: 'ADM2024107',
    classId: 'class_9',
    className: 'Class 9',
    mobile: '9876543211',
    totalFee: 45000,
    paidFee: 33000,
    feeBalance: 12000,
    reminderCount: 0,
  },
  {
    studentId: 'stu_d008',
    studentName: 'Divya Menon',
    admissionNo: 'ADM2024108',
    classId: 'class_8',
    className: 'Class 8',
    mobile: '9876543212',
    parentMobile: '9876543213',
    totalFee: 40000,
    paidFee: 32000,
    feeBalance: 8000,
    lastReminderSent: '2026-02-13T15:00:00Z',
    reminderCount: 1,
  },
  {
    studentId: 'stu_d009',
    studentName: 'Arjun Kapoor',
    admissionNo: 'ADM2024109',
    classId: 'class_10',
    className: 'Class 10',
    mobile: '9876543214',
    totalFee: 50000,
    paidFee: 44000,
    feeBalance: 6000,
    reminderCount: 0,
  },
  {
    studentId: 'stu_d010',
    studentName: 'Meera Gupta',
    admissionNo: 'ADM2024110',
    classId: 'class_9',
    className: 'Class 9',
    mobile: '9876543215',
    parentMobile: '9876543216',
    totalFee: 45000,
    paidFee: 41000,
    feeBalance: 4000,
    reminderCount: 0,
  },
];

// ============================================
// MOCK COMMUNICATION HISTORY
// ============================================

export const MOCK_COMMUNICATION_HISTORY: CommunicationHistory[] = [
  {
    id: 'hist_001',
    type: 'ANNOUNCEMENT',
    title: 'Annual Day Celebration',
    summary: 'Announcement sent to all students about Annual Day',
    recipientCount: 850,
    sentAt: '2026-02-10T10:00:00Z',
    sentBy: {
      id: 'user_001',
      name: 'Principal',
    },
    deliveryStatus: DeliveryStatus.DELIVERED,
    readCount: 645,
    failedCount: 0,
  },
  {
    id: 'hist_002',
    type: 'MESSAGE',
    title: 'Homework Reminder',
    summary: 'Message sent to Class 10 students',
    recipientCount: 125,
    sentAt: '2026-02-14T15:00:00Z',
    sentBy: {
      id: 'user_002',
      name: 'John Doe',
    },
    deliveryStatus: DeliveryStatus.DELIVERED,
    readCount: 115,
    failedCount: 2,
  },
  {
    id: 'hist_003',
    type: 'FEE_REMINDER',
    title: 'Fee Payment Reminder',
    summary: 'Reminders sent to 23 defaulters',
    recipientCount: 23,
    sentAt: '2026-02-10T10:00:00Z',
    sentBy: {
      id: 'user_001',
      name: 'Accounts Manager',
    },
    deliveryStatus: DeliveryStatus.DELIVERED,
    readCount: 20,
    failedCount: 0,
  },
];

// Helper function to get unread count
export const getUnreadNotificationCount = (): number => {
  return MOCK_NOTIFICATIONS.filter(n => !n.isRead).length;
};

// ============================================
// MOCK PEOPLE (for New Conversation Dialog search)
// ============================================

export interface MockPerson {
  id: string;
  name: string;
  role: 'STUDENT' | 'EMPLOYEE';
  className?: string;
  department?: string;
}

export const MOCK_PEOPLE: MockPerson[] = [
  { id: 'user_student_001', name: 'Ravi Kumar', role: 'STUDENT', className: '10-A' },
  { id: 'user_student_002', name: 'Priya Sharma', role: 'STUDENT', className: '9-B' },
  { id: 'user_student_003', name: 'Sneha Reddy', role: 'STUDENT', className: '8-C' },
  { id: 'user_student_004', name: 'Arjun Patel', role: 'STUDENT', className: '10-B' },
  { id: 'user_student_005', name: 'Meena Iyer', role: 'STUDENT', className: '7-A' },
  { id: 'user_student_006', name: 'Karan Singh', role: 'STUDENT', className: '11-Science' },
  { id: 'user_student_007', name: 'Divya Nath', role: 'STUDENT', className: '6-B' },
  { id: 'user_emp_001', name: 'Ajay Mehta', role: 'EMPLOYEE', department: 'Science' },
  { id: 'user_emp_002', name: 'Deepa Nair', role: 'EMPLOYEE', department: 'Mathematics' },
  { id: 'user_emp_003', name: 'Suresh Pillai', role: 'EMPLOYEE', department: 'English' },
  { id: 'user_emp_004', name: 'Ananya Das', role: 'EMPLOYEE', department: 'Social Studies' },
  { id: 'user_emp_005', name: 'Ramesh Yadav', role: 'EMPLOYEE', department: 'Physical Education' },
];

// ============================================
// MOCK CONVERSATIONS (DIRECT MESSAGING)
// ============================================

import { Conversation, ChatMessage } from '../types/communication';

export const MOCK_CONVERSATIONS: Conversation[] = [
  {
    id: 'conv_001',
    participant: {
      id: 'user_student_001',
      name: 'Ravi Kumar',
      role: 'STUDENT',
      className: '10-A',
    },
    lastMessage: {
      content: 'Ok sir, noted. I will submit it today.',
      sentAt: '2026-02-20T10:32:00Z',
      sentByMe: false,
    },
    unreadCount: 2,
    updatedAt: '2026-02-20T10:32:00Z',
  },
  {
    id: 'conv_002',
    participant: {
      id: 'user_student_002',
      name: 'Priya Sharma',
      role: 'STUDENT',
      className: '9-B',
    },
    lastMessage: {
      content: 'Noted, thanks for letting me know!',
      sentAt: '2026-02-19T16:45:00Z',
      sentByMe: false,
    },
    unreadCount: 0,
    updatedAt: '2026-02-19T16:45:00Z',
  },
  {
    id: 'conv_003',
    participant: {
      id: 'user_emp_001',
      name: 'Ajay Mehta',
      role: 'EMPLOYEE',
      department: 'Science',
    },
    lastMessage: {
      content: 'Will do, I will prepare the lab schedule.',
      sentAt: '2026-02-19T09:15:00Z',
      sentByMe: false,
    },
    unreadCount: 0,
    updatedAt: '2026-02-19T09:15:00Z',
  },
  {
    id: 'conv_004',
    participant: {
      id: 'user_student_003',
      name: 'Sneha Reddy',
      role: 'STUDENT',
      className: '8-C',
    },
    lastMessage: {
      content: 'Please make sure you bring the permission slip tomorrow.',
      sentAt: '2026-02-18T14:00:00Z',
      sentByMe: true,
    },
    unreadCount: 0,
    updatedAt: '2026-02-18T14:00:00Z',
  },
  {
    id: 'conv_005',
    participant: {
      id: 'user_emp_002',
      name: 'Deepa Nair',
      role: 'EMPLOYEE',
      department: 'Mathematics',
    },
    lastMessage: {
      content: 'The exam schedule has been updated. Please check the portal.',
      sentAt: '2026-02-17T11:30:00Z',
      sentByMe: true,
    },
    unreadCount: 0,
    updatedAt: '2026-02-17T11:30:00Z',
  },
  {
    id: 'conv_006',
    participant: {
      id: 'user_student_004',
      name: 'Arjun Patel',
      role: 'STUDENT',
      className: '10-B',
    },
    lastMessage: null,
    unreadCount: 0,
    updatedAt: '2026-02-16T08:00:00Z',
  },
];

export const MOCK_CHAT_MESSAGES: Record<string, ChatMessage[]> = {
  conv_001: [
    {
      id: 'msg_001_1',
      conversationId: 'conv_001',
      content: 'Please submit your science assignment by end of day.',
      sentBy: { id: 'user_current', name: 'Mr. Sharma' },
      sentAt: '2026-02-20T10:30:00Z',
      isRead: true,
      isMine: true,
    },
    {
      id: 'msg_001_2',
      conversationId: 'conv_001',
      content: 'Ok sir, noted. I will submit it today.',
      sentBy: { id: 'user_student_001', name: 'Ravi Kumar' },
      sentAt: '2026-02-20T10:32:00Z',
      isRead: false,
      isMine: false,
    },
    {
      id: 'msg_001_3',
      conversationId: 'conv_001',
      content: 'Also, please check the corrections I marked on your last submission.',
      sentBy: { id: 'user_current', name: 'Mr. Sharma' },
      sentAt: '2026-02-19T14:10:00Z',
      isRead: true,
      isMine: true,
    },
    {
      id: 'msg_001_4',
      conversationId: 'conv_001',
      content: 'Thank you sir, I have noted all corrections.',
      sentBy: { id: 'user_student_001', name: 'Ravi Kumar' },
      sentAt: '2026-02-19T14:25:00Z',
      isRead: false,
      isMine: false,
    },
  ],
  conv_002: [
    {
      id: 'msg_002_1',
      conversationId: 'conv_002',
      content: 'Priya, your project presentation is scheduled for Friday at 2 PM.',
      sentBy: { id: 'user_current', name: 'Mr. Sharma' },
      sentAt: '2026-02-19T15:00:00Z',
      isRead: true,
      isMine: true,
    },
    {
      id: 'msg_002_2',
      conversationId: 'conv_002',
      content: 'Noted, thanks for letting me know!',
      sentBy: { id: 'user_student_002', name: 'Priya Sharma' },
      sentAt: '2026-02-19T16:45:00Z',
      isRead: true,
      isMine: false,
    },
  ],
  conv_003: [
    {
      id: 'msg_003_1',
      conversationId: 'conv_003',
      content: 'Ajay, can you prepare the lab schedule for next week?',
      sentBy: { id: 'user_current', name: 'Mr. Sharma' },
      sentAt: '2026-02-19T09:00:00Z',
      isRead: true,
      isMine: true,
    },
    {
      id: 'msg_003_2',
      conversationId: 'conv_003',
      content: 'Will do, I will prepare the lab schedule.',
      sentBy: { id: 'user_emp_001', name: 'Ajay Mehta' },
      sentAt: '2026-02-19T09:15:00Z',
      isRead: true,
      isMine: false,
    },
  ],
  conv_004: [
    {
      id: 'msg_004_1',
      conversationId: 'conv_004',
      content: 'Sneha, you need to get the field trip permission slip signed by your parents.',
      sentBy: { id: 'user_current', name: 'Mr. Sharma' },
      sentAt: '2026-02-18T13:30:00Z',
      isRead: true,
      isMine: true,
    },
    {
      id: 'msg_004_2',
      conversationId: 'conv_004',
      content: 'Ok sir, I will get it done.',
      sentBy: { id: 'user_student_003', name: 'Sneha Reddy' },
      sentAt: '2026-02-18T13:45:00Z',
      isRead: true,
      isMine: false,
    },
    {
      id: 'msg_004_3',
      conversationId: 'conv_004',
      content: 'Please make sure you bring the permission slip tomorrow.',
      sentBy: { id: 'user_current', name: 'Mr. Sharma' },
      sentAt: '2026-02-18T14:00:00Z',
      isRead: true,
      isMine: true,
    },
  ],
  conv_005: [
    {
      id: 'msg_005_1',
      conversationId: 'conv_005',
      content: 'The exam schedule has been updated. Please check the portal.',
      sentBy: { id: 'user_current', name: 'Mr. Sharma' },
      sentAt: '2026-02-17T11:30:00Z',
      isRead: true,
      isMine: true,
    },
  ],
  conv_006: [],
};
